
import { SliderColorsOptions } from "../sliderColors";
import { SC_SlideButtonProps } from "./SlideButton.styled";

const removeSizeBullet = (sizeBullet: any, size: number) => {
    return ((sizeBullet / 2) + (size / 2));
}

const calcSpacePorcentBullet = (value: number, leng: number) => {
    return value * (100 / (leng - 1))
}

export const calcSlideButtonLeft = (color: SliderColorsOptions, value: number, leng: number, sizeBullet: number, size: number):SC_SlideButtonProps => {
    return {
        point: {
            left: `calc(${calcSpacePorcentBullet(value, leng)}% + -${removeSizeBullet(sizeBullet, size)}px)`,
            width: `${sizeBullet}px`
        },
        color
    };
};